import React from 'react';

import Menu from '../Menu';
import { menuLinks, sections, bestPracticesDefault } from './../constants'
import ils_19 from './../images/assets/ils_19.svg';

import ServiceContent from './ServiceContent';

const title = sections.services.dataEngineering.page.title
const description = 'Modern Data Engineering & MLOps built on AWS cloud infrastructure. We design and implement scalable data pipelines, automate ML model training and deployment, and optimize data lakes for performance and cost. Our expertise spans AWS services (Step Functions, Glue, Kinesis, SageMaker, Bedrock) with serverless architecture and real-time processing capabilities. From ETL pipelines to model monitoring and drift detection, we ensure your data and ML infrastructure is production-ready.'
const useCases = [
	'Automated ML model retraining pipelines with AWS Step Functions',
	'Real-time model serving with auto-scaling and load balancing',
	'Model performance monitoring and drift detection systems',
	'Feature store implementation and management',
	'CI/CD pipelines for ML model deployment',
	'Gather Business Intelligence from existing data sources',
	'Optimize speed and reduce costs on existing data lakes',
	'Stream and batch processing with AWS Kinesis and Glue',
	'AWS Bedrock integration for managed LLM/AI services',
	'Improve reliability and observability of data lakes'
]
const bestPractices = bestPracticesDefault.concat([
	'Automated ML workflow orchestration with AWS Step Functions',
	'Model versioning and experiment tracking',
	'Real-time inference pipelines with auto-scaling',
	'Infrastructure as Code for reproducible deployments',
	'Comprehensive monitoring and alerting for ML systems'
])

const faqs = [
	{
		question: "What is MLOps and why is it important?",
		answer: "MLOps (Machine Learning Operations) applies DevOps practices to machine learning systems. It automates ML model training, deployment, monitoring, and retraining to ensure models perform reliably in production. CaptainMe AI implements MLOps on AWS using SageMaker, Step Functions, and CI/CD pipelines for continuous model improvement."
	},
	{
		question: "How do you optimize data lake costs on AWS?",
		answer: "We optimize AWS data lake costs through intelligent storage tiering (S3 Standard to Glacier), query optimization with Athena partitioning, serverless ETL with Glue to eliminate idle compute, and Kinesis stream right-sizing. We also implement data lifecycle policies and compression strategies to reduce storage and transfer costs."
	},
	{
		question: "What is model drift detection and why does it matter?",
		answer: "Model drift occurs when an ML model's performance degrades over time because the real-world data distribution changes from what the model was trained on. CaptainMe AI implements automated drift detection systems that continuously monitor model predictions, detect statistical shifts in input data and output distributions, and trigger automated retraining pipelines when performance thresholds are breached."
	}
]

function ServiceDataEngineering() {
	return (
		<React.Fragment>
			< Menu />

			<ServiceContent
				pageTitle='Data Engineering & ML Ops'
				title={title}
				description={description}
				img={ils_19}
				useCases={useCases}
				bestPractices={bestPractices}
				breadCrumpMenu={sections.services.dataEngineering.title}
				currentMenuPage={menuLinks.servicesDataEngineering}
				faqs={faqs}
			/>

		</React.Fragment>
	)
}

export default ServiceDataEngineering;
